var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { idbStorage } from '../store/idbStorage';
export var downloadFile = function (file) {
    var link = document.createElement('a');
    try {
        var href = URL.createObjectURL(file);
        link.setAttribute('href', href);
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
    }
    catch (error) {
        console.error("Failed to download file: ".concat(file.name), error);
    }
    finally {
        document.body.removeChild(link);
    }
};
export var idbKeys = [
    'filter-store',
    'filter-configuration-store',
    'editor-content',
    'onboarding-complete',
    'background-image-selected',
    'feature-flags',
];
export var legacyLocalStorageKeys = [
    'modular-filter-storage',
    'modular-filter-storage-migrated',
];
export var allStorageKeys = __spreadArray(__spreadArray([], idbKeys, true), legacyLocalStorageKeys, true);
export var localState = function () { return __awaiter(void 0, void 0, void 0, function () {
    var idbEntries, lsEntries;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(idbKeys.map(function (key) { return __awaiter(void 0, void 0, void 0, function () {
                    var value;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, idbStorage.getItem(key)];
                            case 1:
                                value = _a.sent();
                                return [2 /*return*/, [key, value]];
                        }
                    });
                }); }))];
            case 1:
                idbEntries = _a.sent();
                lsEntries = legacyLocalStorageKeys
                    .map(function (key) {
                    var raw = localStorage.getItem(key);
                    return [key, raw !== null ? JSON.parse(raw) : null];
                })
                    .filter(function (_a) {
                    var v = _a[1];
                    return v !== null;
                });
                return [2 /*return*/, Object.fromEntries(__spreadArray(__spreadArray([], idbEntries, true), lsEntries, true).filter(function (_a) {
                        var v = _a[1];
                        return v !== null;
                    }))];
        }
    });
}); };
export var uploadState = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    var _i, _a, _b, key, value, parsed, serialized;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _i = 0, _a = Object.entries(state);
                _c.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 5];
                _b = _a[_i], key = _b[0], value = _b[1];
                if (!idbKeys.includes(key)) return [3 /*break*/, 3];
                parsed = typeof value === 'string' ? JSON.parse(value) : value;
                return [4 /*yield*/, idbStorage.setItem(key, parsed)];
            case 2:
                _c.sent();
                return [3 /*break*/, 4];
            case 3:
                if (legacyLocalStorageKeys.includes(key)) {
                    serialized = typeof value === 'string' ? value : JSON.stringify(value);
                    localStorage.setItem(key, serialized);
                }
                _c.label = 4;
            case 4:
                _i++;
                return [3 /*break*/, 1];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var clearAllState = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(idbKeys.map(function (key) { return idbStorage.removeItem(key); }))];
            case 1:
                _a.sent();
                legacyLocalStorageKeys.forEach(function (key) { return localStorage.removeItem(key); });
                return [2 /*return*/];
        }
    });
}); };
